import React, { useState } from 'react';
import Footer from '../components/Footer';

const faqs = [
  {
    category: 'The Events',
    items: [
      {
        q: 'Is the Welcome Party on Thursday optional?',
        a: 'Yes! The Welcome Party at LaPlaya Beach Club on Thursday evening is optional — but we would love to see you there! It\'s a wonderful way to kick off the weekend, reconnect with friends and family, and get into the Naples spirit before the big day.',
      },
      {
        q: 'What is the dress code for each event?',
        a: '<b>Welcome Party:</b> Coastal Cocktail — polos, button downs, or light sport jackets with trousers or shorts for men. Sundresses or colorful cocktail dresses for women.<br/><br/><b>Wedding Day (Mass + Reception):</b> We are so excited to celebrate in Black Tie attire — tuxedos for gentlemen and floor-length dresses for women.<br/><br/><i>Please note that the Welcome Party and cocktail hour will be outdoors on grass — please dress and plan footwear accordingly!</i>',
      },
      {
        q: 'Will there be a shuttle service?',
        a: 'Yes! Shuttle service will run to and from the Naples Beach Club, A Four Seasons Resort throughout the wedding weekend.',
      },
    ],
  },
  {
    category: 'Travel & Accommodations',
    items: [
      {
        q: 'When should I book my hotel room?',
        a: 'We recommend booking as soon as possible! The room block at the Naples Beach Club, A Four Seasons Resort must be booked by September 1, 2026 to receive the group rate. Use promo code 261001CCW when booking at fourseasons.com or by calling (239) 944-7600.',
      },
      {
        q: 'Do I have to stay at the Naples Beach Club?',
        a: 'You\'re welcome to stay anywhere you\'d like! However, please note that shuttle service during the wedding weekend will run exclusively to and from the Naples Beach Club. If you stay elsewhere, you\'ll need to arrange your own transportation.',
      },
      {
        q: 'What is the closest airport?',
        a: 'Southwest Florida International Airport (RSW) is approximately 40 minutes from Naples and is served by most major airlines.',
      },
      {
        q: 'What\'s the weather like in Naples in October?',
        a: 'October is one of the best times to visit Naples! Expect warm temperatures in the low-to-mid 80s°F with lower humidity than summer. Evenings can be slightly cooler, so bring a light wrap for outdoor events.',
      },
    ],
  },
  {
    category: 'RSVPs & Guests',
    items: [
      {
        q: 'When is the RSVP deadline?',
        a: 'We kindly ask that you RSVP by September 18, 2026. This gives us time to finalize seating, catering, and all the details that make the celebration perfect.',
      },
      {
        q: 'Can I bring a plus one?',
        a: 'Plus ones are noted on your invitation. If you have questions about your invitation, please reach out to us directly and we\'ll be happy to clarify.',
      },
{
        q: 'I have a dietary restriction — what should I do?',
        a: 'Please note any dietary restrictions when you RSVP. We want everyone to enjoy the celebration to the fullest, and we\'re happy to accommodate your needs.',
      },
    ],
  },
];

export default function FAQ() {
  const [openItems, setOpenItems] = useState({});

  const toggle = (key) => {
    setOpenItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="site-wrapper">
      <div className="rsvp-bg-photo" style={{ backgroundImage: "url('/Sign in Page.jpeg')" }} />
      <div className="rsvp-bg-overlay" />

      <div className="page-content" style={{ position: 'relative', zIndex: 2 }}>
        <div className="faq-content" style={{ maxWidth: '860px', margin: '0 auto', padding: '40px 40px 80px' }}>
          <h2 style={{
            fontFamily: 'var(--font-script)',
            fontSize: '60px',
            fontWeight: 400,
            color: 'var(--green-dark)',
            textAlign: 'center',
            marginBottom: '8px',
            lineHeight: 1.2,
          }}>Frequently Asked Questions</h2>
          <p style={{
            textAlign: 'center',
            marginBottom: '48px',
            fontWeight: 600,
            fontSize: '1rem',
            color: 'grey',
          }}>
            Everything you need to know about Caroline &amp; Michael's wedding weekend.
          </p>

          {faqs.map((group) => (
            <div key={group.category}>
              <div className="faq-category-label">{group.category}</div>
              <div className="faq-list" style={{ marginBottom: '40px' }}>
                {group.items.map((item) => {
                  const key = `${group.category}::${item.q}`;
                  const isOpen = !!openItems[key];
                  return (
                    <div className={`faq-item ${isOpen ? 'open' : ''}`} key={item.q}>
                      <button className="faq-question" onClick={() => toggle(key)}>
                        <span className="faq-question-text">{item.q}</span>
                        <span className="faq-icon">+</span>
                      </button>
                      <div className="faq-answer">
                        <p dangerouslySetInnerHTML={{ __html: item.a }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          <div className="card-sm" style={{ textAlign: 'center', marginTop: '24px', background: 'var(--green-pale)', border: '1px solid rgba(61,107,53,0.15)' }}>
            <div style={{ fontFamily: 'var(--font-serif)', fontSize: '1.4rem', color: 'var(--green-dark)', marginBottom: '8px' }}>
              Still have questions?
            </div>
            <p style={{ fontFamily: 'var(--font-sans)', fontSize: '0.82rem', color: 'var(--text-medium)', fontWeight: 300, margin: 0 }}>
              We're happy to help with anything. Don't hesitate to reach out — we can't wait to celebrate with you!
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
